export const apiCreate = (): string => '/commercial/notices/create/'
export const apiList = (id?: string): string =>
  !id ? '/commercial/notices/' : `/commercial/notices/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/notices/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/notices/delete/${id}`
